import axios from "axios";
import { apiErrorHandler } from "./helper/handler";

const prefix = "assign-doctor";

const GET_ROOM_DOCTOR_URL = `${prefix}/get`;
const GET_DOCTOR_SCHEDULE_URL = `${prefix}/get-doctor-schedule`;
const CREATE_ROOM_DOCTOR_URL = `${prefix}/create`;
const UPDATE_ROOM_DOCTOR_URL = `${prefix}/update-by-id`;
const DELETE_ROOM_DOCTOR_URL = `${prefix}/delete-by-id`;

/**
 * @func getRoomDoctor
 * @desc get all user data
 * @author jew
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} user array
 */
export const getRoomDoctor = async (queryParams, signal) => {
    try {
        const { data, status } = await axios.get(GET_ROOM_DOCTOR_URL, {
            params: queryParams,
            signal,
        });
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getRoomDoctor");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getRoomDoctor */

/**
 * @func getDoctorSchedule
 * @desc get all user data
 * @author jew
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} user array
 */
export const getDoctorSchedule = async signal => {
    try {
        const { data, status } = await axios.get(GET_DOCTOR_SCHEDULE_URL, {
            signal,
        });
        if (status === 200) {
            return data?.data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getDoctorSchedule");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getRoomDoctor */

/**
 * @func createRoomDoctor
 * @desc user register
 * @author jew
 * @param {Object} body - create user body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean|undefined} create status
 */
export const createRoomDoctor = async (body, signal) => {
    try {
        const { status } = await axios.post(CREATE_ROOM_DOCTOR_URL, body, { signal });
        if (status === 201) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "createRoomDoctor");
        if (err) throw err;
        return undefined;
    }
};
/** End @func createRoomDoctor */

/**
/**
 * @func updateRoomDoctor
 * @desc update user by id
 * @author jew
 * @param {number} id - user id
 * @param {Object} body - update user body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean|undefined} update status
 */
export const updateRoomDoctor = async (id, body, signal) => {
    try {
        const { status } = await axios.put(`${UPDATE_ROOM_DOCTOR_URL}/${id}`, body, { signal });
        if (status === 200) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "updateRoomDoctor");
        if (err) throw err;
        return undefined;
    }
};
/** End @func updateRoomDoctor */

/**
/**
 * @func deleteRoomDoctor
 * @desc update user by id
 * @author jew
 * @param {number} id - user id
 * @param {Object} body - update user body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean|undefined} update status
 */
export const deleteRoomDoctor = async (id, signal) => {
    try {
        const { status } = await axios.delete(`${DELETE_ROOM_DOCTOR_URL}/${id}`, { signal });
        if (status === 200) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "deleteRoomDoctor");
        if (err) throw err;
        return undefined;
    }
};
/** End @func deleteRoomDoctor */
